import { motion } from 'framer-motion';
import { FiGithub, FiLinkedin, FiArrowDown, FiMapPin } from 'react-icons/fi';
import Scene3D from './Scene3D';

const fadeUp = (delay = 0) => ({
  initial: { opacity: 0, y: 32 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] },
});

export default function Hero() {
  return (
    <section id="home" style={{ position: 'relative', height: '100vh', minHeight: 700, overflow: 'hidden', display: 'flex', alignItems: 'center' }}>
      <div style={{ position: 'absolute', inset: 0, zIndex: 0 }}>
        <Scene3D />
      </div>
      <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to right, rgba(6,8,15,0.88) 45%, transparent 100%)', zIndex: 1, pointerEvents: 'none' }} />
      <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: '35%', background: 'linear-gradient(to top, #06080f, transparent)', zIndex: 1, pointerEvents: 'none' }} />

      <div className="section-container" style={{ position: 'relative', zIndex: 2, width: '100%' }}>
        <motion.div {...fadeUp(0.1)} style={{ marginBottom: '2rem', display: 'inline-flex' }}>
          <span style={{
            display: 'inline-flex', alignItems: 'center', gap: '0.5rem',
            background: 'rgba(255,255,255,0.06)', backdropFilter: 'blur(16px)',
            border: '1px solid rgba(255,255,255,0.1)', borderRadius: '999px',
            padding: '0.4rem 1rem', fontFamily: 'Inter, sans-serif',
            fontSize: '0.78rem', color: 'rgba(240,246,255,0.75)',
          }}>
            <span style={{ width: 7, height: 7, borderRadius: '50%', background: '#22c55e', boxShadow: '0 0 8px #22c55e', flexShrink: 0 }} />
            Available for opportunities
          </span>
        </motion.div>

        <motion.h1 {...fadeUp(0.2)} style={{
          fontFamily: 'Space Grotesk, sans-serif',
          fontSize: 'clamp(3.2rem, 9vw, 7.5rem)',
          fontWeight: 800, lineHeight: 0.95,
          color: '#f0f6ff', letterSpacing: '-0.04em', marginBottom: '0.2rem',
        }}>
          Aryan Dev
        </motion.h1>

        <motion.h1 {...fadeUp(0.3)} style={{
          fontFamily: 'Space Grotesk, sans-serif',
          fontSize: 'clamp(3.2rem, 9vw, 7.5rem)',
          fontWeight: 800, lineHeight: 0.95, letterSpacing: '-0.04em', marginBottom: '1.8rem',
          background: 'linear-gradient(135deg, #3b82f6 0%, #8b5cf6 55%, #ec4899 100%)',
          WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text',
        }}>
          Pandey
        </motion.h1>

        <motion.p {...fadeUp(0.4)} style={{
          fontFamily: 'JetBrains Mono, monospace', fontSize: '0.85rem',
          color: 'rgba(240,246,255,0.5)', letterSpacing: '0.04em', marginBottom: '0.5rem',
        }}>
          Full Stack Developer · MERN Stack · Frontend Specialist
        </motion.p>

        <motion.div {...fadeUp(0.45)} style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', marginBottom: '2.5rem' }}>
          <FiMapPin size={12} style={{ color: '#6366f1' }} />
          <span style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.8rem', color: 'rgba(240,246,255,0.38)' }}>
            Sydney, NSW, Australia
          </span>
        </motion.div>

        <motion.div {...fadeUp(0.55)} style={{ display: 'flex', gap: '0.9rem', flexWrap: 'wrap', marginBottom: '2.5rem' }}>
          <a href="#projects" className="glass-btn glass-btn-primary">View My Work</a>
          <a href="#contact" className="glass-btn glass-btn-outline">Get In Touch</a>
        </motion.div>

        <motion.div {...fadeUp(0.65)} style={{ display: 'flex', gap: '0.75rem' }}>
          {[
            { href: 'https://github.com/arbhram', Icon: FiGithub, label: 'GitHub' },
            { href: 'https://www.linkedin.com/in/aryan-dev-pandey-03ab62255/', Icon: FiLinkedin, label: 'LinkedIn' },
          ].map(({ href, Icon, label }) => (
            <a key={label} href={href} target="_blank" rel="noopener noreferrer" aria-label={label}
              style={{
                width: 38, height: 38, borderRadius: '10px',
                background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)',
                backdropFilter: 'blur(12px)', display: 'flex', alignItems: 'center', justifyContent: 'center',
                color: 'rgba(240,246,255,0.55)', fontSize: '1rem', transition: 'all 0.2s',
              }}
              onMouseEnter={e => { e.currentTarget.style.background = 'rgba(99,102,241,0.15)'; e.currentTarget.style.borderColor = 'rgba(99,102,241,0.4)'; e.currentTarget.style.color = '#f0f6ff'; }}
              onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.05)'; e.currentTarget.style.borderColor = 'rgba(255,255,255,0.1)'; e.currentTarget.style.color = 'rgba(240,246,255,0.55)'; }}
            >
              <Icon />
            </a>
          ))}
        </motion.div>
      </div>

      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 2 }}
        style={{ position: 'absolute', bottom: '2.5rem', left: '50%', transform: 'translateX(-50%)', zIndex: 2, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.4rem' }}>
        <span style={{ fontFamily: 'JetBrains Mono, monospace', fontSize: '0.62rem', color: 'rgba(240,246,255,0.22)', letterSpacing: '0.12em', textTransform: 'uppercase' }}>scroll</span>
        <motion.div animate={{ y: [0, 7, 0] }} transition={{ duration: 1.6, repeat: Infinity }} style={{ color: '#6366f1' }}>
          <FiArrowDown size={13} />
        </motion.div>
      </motion.div>
    </section>
  );
}
